import VueGridLayout from 'vue-grid-layout'; 
import BoxWidget from '@plugins/box-widget/box-widget';

export const GridHostComponents = {
  GridLayout: VueGridLayout.GridLayout, 
  GridItem: VueGridLayout.GridItem, 
  BoxWidget,
};
